import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * フォームのエラーメッセージ用 コンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須
 * @param props
 * @returns
 */
export const FormErrorText = (props) => {
    const { children, className = '', noSpace = false } = props;
    return (_jsx(Text, Object.assign({ className: clsx(!noSpace && 'mt-8', className), color: 'error', size: 'xs' }, { children: children })));
};
